import { formatDateAndTime } from '../../../utils/stringUtils'
import { RefundableAmountCard } from './RefundableAmountCard'
import { RefundedAmountCard } from './RefundedAmountCard'
import { TotalAmountCard } from './TotalAmountCard'
import { ClientPaymentDto, ClientPaymentDtoLatestStateEnum } from '../../../../generated-api'

const DetailsTab = ({ payment }: { payment: ClientPaymentDto }) => (
    <div className="rounded-lg rounded-tl-none bg-brand-white shadow-lg py-5 px-5 max-w-4xl">
        <div className="flex flex-col tablet:flex-row tablet:space-x-5 space-y-5 tablet:space-y-0 text-brand-secondary">
            <TotalAmountCard payment={payment} />
            <RefundedAmountCard payment={payment} />
            <RefundableAmountCard currency={payment.currency} refundableAmount={payment.refundableAmount} />
        </div>

        <table className="text-left mt-5">
            <tbody>
                <tr>
                    <th className="pr-5 py-2">Executing location</th>
                    <td>
                        <div className="flex items-center">{payment.executingLocationId}</div>
                    </td>
                </tr>
                <tr>
                    <th className="pr-5 py-2">Payment status</th>
                    <td>
                        <div className="flex items-center">
                            <span
                                className={`rounded-full w-0 inline-block p-2 mr-2 ${
                                    payment.latestState === ClientPaymentDtoLatestStateEnum.CAPTURED
                                        ? 'bg-green-dark'
                                        : payment.latestState === ClientPaymentDtoLatestStateEnum.FAILED
                                        ? 'bg-orange'
                                        : 'bg-yellow-light'
                                }`}
                            />
                            <span>{payment.latestState}</span>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th className="pr-5 py-2">Created</th>
                    <td>{formatDateAndTime(payment.created?.toString() ?? 'No Date')}</td>
                </tr>
                <tr>
                    <th className="pr-5 py-2">Currency</th>
                    <td>{payment.currency}</td>
                </tr>
                <tr>
                    <th className="pr-5 py-2">Payment provider</th>
                    <td>{payment.paymentProvider}</td>
                </tr>
                <tr>
                    <th className="pr-5 py-2">Payment method</th>
                    <td>{payment.paymentMethod}</td>
                </tr>
            </tbody>
        </table>
    </div>
)

export default DetailsTab
